/**
 * FAQ order, shared by FAQSection and the FAQPage schema. The text lives in
 * the `sections` namespace under `faq.items.<id>`.
 */
export const FAQ_IDS = [
  "whatIsThyra",
  "vsChatgpt",
  "autonomy",
  "apps",
  "technical",
  "freePlan",
  "teams",
  "vsAiWorkers",
] as const;

export type FaqId = (typeof FAQ_IDS)[number];
